import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { exportToExcel, ExcelColumn } from '../../utils/exportToExcel';
import Button from './Button';

export interface ExportButtonProps {
  data: any[];
  columns: ExcelColumn<any>[];
  fileName: string;
  sheetName: string;
  disabled?: boolean;
  buttonText?: string;
  variant?: 'primary' | 'secondary';
  className?: string;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  data,
  columns,
  fileName,
  sheetName,
  disabled,
  buttonText = 'Export',
  variant = 'secondary',
  className = '',
}) => {
  const handleExport = () => {
    if (!data.length) return;
    
    const fullFileName = fileName.includes('.xlsx') 
      ? fileName 
      : `${fileName}-${new Date().toISOString().slice(0, 10)}.xlsx`;
    
    exportToExcel({
      fileName: fullFileName,
      sheetName,
      rows: data,
      columns,
    });
  };

  const isDisabled = disabled || !data.length;

  return (
    <Button
      type="button"
      variant={variant}
      onClick={handleExport}
      disabled={isDisabled}
      leftIcon={FiIcons.FiDownload({ className: 'h-4 w-4' })}
      className={className}
    >
      {buttonText}
    </Button>
  );
};

export default ExportButton;
